import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GridLoader from 'react-spinners/GridLoader';
import { createReferralLink } from '../../api-v2/user';
import { Container } from './styles';

const Page = () => {
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const fetchReferralLink = async () => {
			const searchParams = new URLSearchParams(location.search);
			const referralCode = searchParams.get('referralCode');

			if (referralCode) {
				setLoading(true);
				try {
					const response = await createReferralLink(referralCode);
					const { referralLink } = response.data;

					if (referralLink) {
						window.location.href = referralLink;
					} else {
						navigate('/404');
					}
				} catch (error) {
					console.error(error);
					navigate('/404');
				} finally {
					setLoading(false);
				}
			}
		};

		fetchReferralLink();
	}, [location, navigate]);

	return (
		<Container>
			{loading && (
				<>
					<h1 style={{color: "#fff"}}>We are validating your Referral Code...</h1>
					<div className="loading">
						<GridLoader size={80} color="#fff" />
					</div>
				</>
			)}
		</Container>
	);
};

export default Page;
